<template>
  <transition name="wc-confirm-fade">
    <div v-if="visible" class="wc-confirm-overlay" @click.self="cancel">
      <div class="wc-confirm-dialog" role="alertdialog" aria-modal="true" :aria-labelledby="titleId">
        <div class="wc-confirm-icon" :class="'wc-confirm-icon--' + type">
          <i :class="iconClass"></i>
        </div>
        <h5 :id="titleId" class="wc-confirm-title">{{ title }}</h5>
        <p class="wc-confirm-message">{{ message }}</p>
        <div class="wc-confirm-actions">
          <button type="button" class="btn btn-light" @click="cancel">{{ cancelText }}</button>
          <button type="button" class="btn text-white" :class="confirmBtnClass" @click="confirm">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmModal',
  data() {
    return {
      visible: false,
      title: 'Konfirmasi',
      message: 'Apakah Anda yakin?',
      confirmText: 'Ya',
      cancelText: 'Batal',
      type: 'danger',
      resolve: null,
      titleId: 'wc-confirm-title-' + Math.random().toString(36).slice(2, 8),
    }
  },
  computed: {
    iconClass() {
      if (this.type === 'warning') return 'fas fa-exclamation-triangle'
      if (this.type === 'info') return 'fas fa-info-circle'
      return 'fas fa-trash-alt'
    },
    confirmBtnClass() {
      if (this.type === 'warning') return 'btn-warning'
      if (this.type === 'info') return 'btn-primary'
      return 'btn-danger'
    },
  },
  methods: {
    open(options = {}) {
      this.title = options.title || 'Konfirmasi'
      this.message = options.message || 'Apakah Anda yakin?'
      this.confirmText = options.confirmText || 'Ya'
      this.cancelText = options.cancelText || 'Batal'
      this.type = options.type || 'danger'
      this.visible = true
      document.body.style.overflow = 'hidden'
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    confirm() {
      this.close(true)
    },
    cancel() {
      this.close(false)
    },
    close(result) {
      this.visible = false
      document.body.style.overflow = ''
      if (this.resolve) {
        this.resolve(result)
        this.resolve = null
      }
    },
  },
}
</script>

<style scoped>
.wc-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(39, 43, 65, 0.45);
  backdrop-filter: blur(2px);
}

.wc-confirm-dialog {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(39, 43, 65, 0.18);
  padding: 1.75rem 1.5rem 1.5rem;
  text-align: center;
}

.wc-confirm-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 1rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}

.wc-confirm-icon--danger {
  background: rgba(239, 110, 110, 0.12);
  color: #ef6e6e;
}

.wc-confirm-icon--warning {
  background: rgba(255, 188, 52, 0.15);
  color: #d39e00;
}

.wc-confirm-icon--info {
  background: rgba(18, 140, 126, 0.12);
  color: #128c7e;
}

.wc-confirm-title {
  margin: 0 0 0.5rem;
  font-size: 1.15rem;
  font-weight: 600;
  color: #272b41;
}

.wc-confirm-message {
  margin: 0 0 1.5rem;
  color: #6c757d;
  font-size: 0.95rem;
  line-height: 1.5;
  white-space: pre-line;
}

.wc-confirm-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.wc-confirm-actions .btn {
  min-width: 110px;
  border-radius: 8px;
  font-weight: 500;
}

.wc-confirm-fade-enter-active,
.wc-confirm-fade-leave-active {
  transition: opacity 0.18s ease;
}

.wc-confirm-fade-enter-active .wc-confirm-dialog,
.wc-confirm-fade-leave-active .wc-confirm-dialog {
  transition: transform 0.18s ease, opacity 0.18s ease;
}

.wc-confirm-fade-enter,
.wc-confirm-fade-leave-to {
  opacity: 0;
}

.wc-confirm-fade-enter .wc-confirm-dialog,
.wc-confirm-fade-leave-to .wc-confirm-dialog {
  opacity: 0;
  transform: translateY(8px) scale(0.98);
}
</style>
